{{#if hasTabs}}
<div style="height:44px;"></div>
{{/if}}
<div class="col-xs-12 col-sm-4 col-md-3 {{#if tabs}}m-t-45{{/if}}">
	<div id="info-container" class="card-box clearfix scroll-box {{#unless hasValues}}box-color-error{{/unless}}">
		{{#if hasValues}}
			<div id="js-device-values" style="position: relative">
				{{#if canSeeConfig}}
				<div class="row">
					<div class="col-xs-10">
						<h5 class="heading long">{{{COLUMN_DATA device "#_plain_name" undefined}}}</h5>
					</div >
					<div class="col-xs-2">
						{{#if canConfigureValues}}
							<button class="btn btn-white btn-xs pull-right js-value-config-button"><i class="fa fa-cog"></i></button>
						{{/if}}
					</div>
				</div>
				{{/if}}
				<div class="row">
					<div class="col-xs-12">
					<dl>
					{{#each deviceValues.displayData}}
						<dt id="{{id}}" class="description-with-button">
							{{TR_DATAPOINT ../this.deviceID name}}
							{{#if ../this.canWriteValues}}
								{{#unless is_readonly}}
								<button class="btn btn-white btn-xs js-value-edit-button"><i class="glyphicon glyphicon-pencil"></i></button>
								{{/unless}}
							{{/if}}
						</dt>
						<dd>{{value}} {{unit}}
						</dd>
					{{else}}
					{{#unless valuesFetched}}
					<i class="fa fa-spin fa-spinner"></i>
					{{/unless}}
					{{/each}}
					</dl>
					</div>
				</div>
			</div>

			{{#each sensor}}
				<div class="row">
					{{#if ../smartTempFeatureActivated}}
					<div class="col-xs-7">
						<h5 class="heading long">{{{COLUMN_DATA this "#_name" undefined}}}</h5>
					</div>
					<div class="col-xs-5">
							<button class="btn btn-xs pull-right js-smart-temp-button 
							{{#if smartTemp.isActive}} btn-inverse
							{{else}}
								{{#if smartTemp.isDryRun}} btn-white
								{{else}}
									{{#if smartTemp.isPossible}} btn-white
									{{else}}
									disabled btn-grey
									{{/if}}
								{{/if}}
							{{/if}}
							" id="{{id}}">
								<i class="fa fa-flask"></i> {{smartTempBtnText}}
							</button>
					</div>
					{{else}}
					<div class="col-xs-12">
						<h5 class="heading long">{{{COLUMN_DATA this "#_name" undefined}}}</h5>
					</div>
					{{/if}}
				</div>
				{{#if ../smartTempFeatureActivated}}
				<div class="row">
					<div class="col-xs-12">
					<dl>
						<dt id="{{id}}" class="description-with-button">
							{{TR "Zählerposition / erfasste Heizkreise"}}
							{{#if ../this.canWriteValues}}
								{{#unless is_readonly}}
									<button class="btn btn-xs js-hcs-config-button 
									{{#if smartTemp.isActive}} disabled btn-grey
									{{else}}
										{{#if smartTemp.isDryRun}} disabled btn-grey
										{{else}} btn-white
										{{/if}}
									{{/if}}" id="{{id}}"><i class="glyphicon glyphicon-pencil"></i></button>
								{{/unless}}
							{{/if}}
						</dt>
						{{#each hcs}}
							<dd>{{this}}
							</dd>
						{{/each}}
					</dl>
					</div>
				</div>
				{{/if}}
				<dl>
					{{#each this.displayData}}
						<dt>{{TR_DATAPOINT ../../this.deviceID name}}</dt>
						<dd >{{value}} {{unit}}</dd>
					{{/each}}
				</dl>
			{{/each}}
			{{else}}
			<span>{{TR "Zählerdaten konnten nicht geladen werden"}}</span>
			{{/if}}
	</div>
</div>
